import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
let TextEditor = class TextEditor extends Vue {
    constructor() {
        super(...arguments);
        this.workingValue = this.value;
        this.isEditingStateful = false;
    }
    get isActuallyEditing() {
        return this.isEditing || (this.hasOwnState && this.isEditingStateful);
    }
    get isInvalid() {
        return this.validate && !this.validate(this.workingValue);
    }
    get source() {
        return this.label ? `**${this.label}:** ${this.value}` : this.value;
    }
    handleOpen() {
        this.isEditingStateful = true;
        this.workingValue = this.value;
    }
    handleEdit(event) {
        this.$emit('input', this.workingValue);
        this.$emit('close', event);
        this.isEditingStateful = false;
    }
    handleClose(event) {
        this.workingValue = this.value;
        this.$emit('close', event);
        this.isEditingStateful = false;
    }
};
__decorate([
    Prop(String)
], TextEditor.prototype, "label", void 0);
__decorate([
    Prop(String)
], TextEditor.prototype, "placeholder", void 0);
__decorate([
    Prop(String)
], TextEditor.prototype, "value", void 0);
__decorate([
    Prop(Boolean)
], TextEditor.prototype, "isEditing", void 0);
__decorate([
    Prop(Boolean)
], TextEditor.prototype, "hasOwnState", void 0);
__decorate([
    Prop(Function)
], TextEditor.prototype, "validate", void 0);
TextEditor = __decorate([
    Component({
        components: {
            VueMarkdown
        }
    })
], TextEditor);
export default TextEditor;
